import { render, staticRenderFns } from "./modal-component.vue?vue&type=template&id=5bd4934c&scoped=true&"
import script from "./modal-component.vue?vue&type=script&lang=js&"
export * from "./modal-component.vue?vue&type=script&lang=js&"
import style0 from "./modal-component.vue?vue&type=style&index=0&id=5bd4934c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4934c",
  null
  
)

export default component.exports